<template>
  <div class="select-tag">
    <div class="list">
      <template v-for="item in options">
        <a-tag v-if="tags.includes(item.value)" color="#2db7f5" :key="item.value"> {{ item.label }} </a-tag>
      </template>
      <a-tag style="cursor: pointer" color="#108ee9" @click="visible = true"> <a-icon type="plus" /> 添加标签 </a-tag>
    </div>
    <a-modal title="选择标签" :visible="visible" okText="确定" cancelText="取消" :closable="false" @cancel="visible = false" @ok="visible = false">
      <a-checkbox-group v-model="tags" :options="options" @change="handleChange"> </a-checkbox-group>
    </a-modal>
  </div>
</template>

<script>
import { queryTagListApi } from '@/api/Site/Create'
export default {
  data() {
    return {
      options: [],
      visible: false,
      tags: []
    }
  },
  created() {
    this.queryTagList()
  },
  props: ['value'],
  methods: {
    handleChange() {
      let result = this.options.filter((item) => {
        return this.tags.includes(item.value)
      })
      result = result.map((item) => {
        return {
          spiderTagName: item.label,
          spiderTagId: item.value
        }
      })
      this.$emit('input', result)
    },
    async queryTagList() {
      let query = {

      }
      let res = await queryTagListApi(query)
      let { code, msg, data } = res
      if (code == '200') {
        this.options = data.map((item) => {
          return {
            label: item.spiderTagName,
            value: item.spiderTagId
          }
        })
      } else {
        this.$message.error(msg)
      }
    }
  },
  watch: {
    value: {
      handler() {
        if (this.value) {
          this.tags = this.value.map((item) => item.spiderTagId)
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="less" scoped></style>
